module.exports = __webpack_public_path__ + "img/2f0abd0faa801c06a3601d5d8ea79942.3a9ca053.png";